// Whitsett Theme JS

// Mobile nav toggle
function toggleMobileNav() {
  const nav = document.getElementById('mobile-nav');
  nav.classList.toggle('open');
}

// Close mobile nav on link click
document.querySelectorAll('.mobile-nav-link').forEach(link => {
  link.addEventListener('click', () => {
    document.getElementById('mobile-nav').classList.remove('open');
  });
});

// Product page: thumbnail switcher
function setMainImage(thumb) {
  const main = document.getElementById('product-main-img');
  if (!main) return;
  document.querySelectorAll('.product-page__thumb').forEach(t => t.classList.remove('active'));
  thumb.classList.add('active');
  main.src = thumb.src;
}

// Product page: variant selector
document.querySelectorAll('.variant-btn').forEach(btn => {
  btn.addEventListener('click', function() {
    const group = this.closest('.variant-options');
    group.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
    this.classList.add('active');
  });
});

// Smooth scroll for anchor links
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function(e) {
    const target = document.querySelector(this.getAttribute('href'));
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth' });
    }
  });
});

// Email signup form (Shopify handles the actual submission via action="/contact#contact_form")
// This just prevents double-submit
const emailForm = document.querySelector('.email-section__form');
if (emailForm) {
  emailForm.addEventListener('submit', function() {
    const btn = this.querySelector('.email-section__submit');
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Subscribed!';
    }
  });
}

// Add to cart feedback
const addToCartBtn = document.querySelector('.product-page__add');
if (addToCartBtn) {
  addToCartBtn.addEventListener('click', function() {
    const original = this.textContent;
    this.textContent = 'Added!';
    this.style.background = '#d0d0d0';
    setTimeout(() => {
      this.textContent = original;
      this.style.background = '';
    }, 1500);
  });
}
